import { Component } from '@angular/core';
import { ViewAllCompaniesComponent } from '../../../../components/admin-dashboard-component/admin-companies-component/view-all-companies-component/view-all-companies-component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-view-all-companies',
  imports: [ViewAllCompaniesComponent, RouterLink],
  templateUrl: './view-all-companies.html',
  styleUrl: './view-all-companies.scss',
})
export class ViewAllCompanies {}
